import { ApplicationField } from './application-field';

/**
 * Client clientApp field is once the client has created an clientApp -- this is a saved field in that clientApp.
 * It maps to the questions that get answered related to this field.
 */
export class ClientApplicationField {
    clientApplicationFieldId: string;
    applicationFieldId: string;
    field: ApplicationField;
    sortOrder: number;

    constructor(body: any) {
        this.clientApplicationFieldId = body.id;
        this.applicationFieldId = body.applicationFieldId;
        this.field = new ApplicationField(body.field);
        this.sortOrder = body.sortOrder;
    }
}
